<template>
	<div class="cofig-list">
		<gc-sub-title icon="icon-shebei1" text="配置列表" />
		<ul class="list">
			<li
				v-for="item in list"
				:key="item.value"
				class="list-item"
				:class="{ active: selectConfig.value === item.value }"
				@click="handleListItemClick(item)"
			>
				<span class="label">{{ item.label || '--' }}</span>
				<span class="num">{{ item.number || 0 }}</span>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'ConfigList',
	model: {
		prop: 'modelValue',
		event: 'update:modelValue',
	},
	props: {
		modelValue: {
			type: Object,
			default: () => ({}),
		},
		list: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			selectConfig: {},
		}
	},
	watch: {
		modelValue: {
			handler(val) {
				this.selectConfig = val
			},
		},
	},
	methods: {
		handleListItemClick(item) {
			this.selectConfig = item
			this.$emit('click', item)
			this.$emit('update:modelValue', item)
		},
	},
}
</script>

<style scoped lang="scss">
.cofig-list {
	height: 100%;
	overflow: hidden;
}
.list {
	margin-top: 30px;
	height: calc(100% - 54px);
	overflow-y: auto;
}
.list-item {
	display: flex;
	align-items: center;
	cursor: pointer;
	height: 40px;
	line-height: 40px;
	padding: 0 13px;
	background: #f0f0f0;
	font-weight: 400;
	color: #666666;
	border-radius: 8px;
	&.active {
		background: #ebedfa;
		color: #4d6bff;
	}
	& + & {
		margin-top: 10px;
	}
}

.label {
	margin-right: auto;
}

.num {
	box-sizing: border-box;
	height: 24px;
	padding: 4px 10px;
	border-radius: 0.2em;
	background-color: #fff;
	line-height: 16px;
}
</style>
